import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    namespaced: true,
    state:{
        // ws20:'ws://192.168.1.121:36688', //真实账号接口 测试
        ws20:'wss://mt4live20.jrjrtrade.com:36688/', //20真实账号接口 正式
        ws30:'wss://mt4live30.jrjrtrade.com:36699/', //30真实账号接口 正式
        ws51:'wss://mt4live51.jrjrtrade.com:36651',//51真实账号接口 正式
        mnws:'wss://mt4demo10.jrjrtrade.com:36686',//10模拟账号接口 正式
        hqws:"wss://hqws20.jrjrtrade.com:38820/",//20行情接口 正式
        ws70:"wss://mt5api70h5.jrjrtrade.com:36675/",//70真实账号接口正式

        contentshow:true,//首先显示真实账户banner

        login: false,//真实账号是否登录
        mnlogin:false,//模拟账号是否登录

        loginUser:null,//账号(真实账号)
        loginPwd:null,//密码(真实账号)

        mnloginUser:null,//账号(模拟账号)
        mnloginPwd:null,//密码(模拟账号)

        headericon:0,
        accountrealbox:false, //判断是否真实账户弹窗
        accountfalsebox:false, //判断是否模拟账户弹窗
        account:'金荣中国真实账户',//login页面判断已登录状态真实或者模拟按钮显示隐藏
        mnaccount:'金荣中国模拟账户',

        realcorrectshow:true,//默认真实账户勾显示
        mncorrectshow:false,//默认模拟账户勾隐藏
        accountshow:true, //判断顶部账号显示隐藏
        contentshow:true,// 所有页面中心内容显示隐藏,mask显示隐藏

        getAllBuyprofit:0, //所有买入盈亏

        goldBuy:0,//伦敦金买入市场价
        goldSell:0,//伦敦金卖出市场价

        silverBuy:0 , //伦敦银买入市场价
        silverSell:0, //伦敦银卖出市场价

        goldindex:true,//dealprice用来判断是否伦敦金页面
        // silverindex:false,
        
        dealtype:'限价买入',//黄金交易类型
        sldealtype:'限价买入',//白银交易类型

        chicanglength:null,//提示持仓单数
        guadanlength:null,//提示挂单单数

        payment:null, //可用预付款

        orderDirection:null,
        openPrice:null,
        symbol:null,
        ticket:null,
        openTime:null,
        lots:null,
        expiration:null,
        stopLoss:null,
        takeProfit:null,
        news:null,

        isprofession:null,//false为非专业投资者，true为专业投资者
        dealgold:null,//XAU或者GOLD
        dealsilver:null,//XAG或者SILVER
        goldstopsLevel:null, //获取黄金挂单距离
        silverstopsLevel:null, //获取白银挂单距离
        stopsLevel:null, //获取挂单距离
        getisgold:false,//撤单判断是否黄金

        pcconfirm:false,//判断平仓点击时间选择的页面
        sxconfirm:false,//判断失效点击时间选择的页面
        mxconfirm:false,//判断明细点击时间选择的页面

        // pcstarttime:null,
        // pcendtime:null,

        goldchanggezhisun:null,//黄金止损点数转换为止损价
        goldchanggezhiying:null,//黄金止盈点数转换为止盈价
        changgezhisun:null,//白银止损点数转换为止损价
        changgezhiying:null,//白银止盈点数转换为止盈价

        confirmrevised:false,

        ordertipshow:false,//全局订单推送显示隐藏
        orderticket:null,//全局消息推送订单号
        ordertype:null,//全局消息推送类型
        orderopentime:null,//全局消息推送建立订单时间
        orderdeal:null,//全局推送市价买入或卖出
        orderclosetime:null,//全局消息推送撤销订单时间
        orderopenprice:null,//全局消息推送建立订单价格
        ordercloseprice:null,//全局消息推送撤销订单价格
        orderlots:null,//全局消息推送手数
        ordersymbol:null,//全局消息推送交易品类

        tips:false,//网络掉线提示

        mt:null,//是否mt5
        stopLimit:null,//修改挂单的停损限价
    },

    //相当于computed
    getters:{
        getterSocketData (state) {
            return state.payment
        },
        getgoldindex(state){
            return state.goldindex
        },
        isisprofession(state){
            return state.isprofession
        }
        // getordertips(state){
        //     return state.orderticket
        // }
        // getsilverindex(state){
        //     return state.silverindex
        // }
    }

})



// WEBPACK FOOTER //
// ./src/store/index.js